import React from "react";
import { HeaderAlt } from "app/header/Header";
import HeaderTitle from "app/header/parts/HeaderTitle";
import ErrorBoundary from "lib/ErrorBoundary";
import useIsMobile from "lib/hooks/useIsMobile";
import { useIsPublicPage } from "lib/routing";
import { Nav, Navbar } from "react-bootstrap";
import { MenuDataProvider } from "../menuFilterBar/parts/menuDataProvider";
import { MenuFilterBar } from "../menuFilterBar/MenuFilterBar";
import { PreferencesDialog } from "../preferences/PreferencesDialog";
import { isRedesignPage, useIsRedesign } from "../preferences/redesignUtils";
import { AssetClassBar } from "./desktop/DesktopHeaderParts/DesktopHeaderParts";
import { TopLinksBar } from "./desktop/TopLinksBar/TopLinksBar";
import { MobileMenu, MobileMenuButton } from "./mobile/MobileMenu";
import "./headerRedesign.css";

export function Header() {
  const isPublic = useIsPublicPage();
  const isMobile = useIsMobile();
  const isRedesign = useIsRedesign();

  if (isPublic) return null;
  if (!isRedesign) return <HeaderAlt />; // render legacy header

  return (
    <ErrorBoundary>
      <MenuDataProvider>{isMobile ? <MobileHeader /> : <DesktopHeader />}</MenuDataProvider>
      <PreferencesDialog />
    </ErrorBoundary>
  );
}

export function DesktopHeader() {
  return (
    <>
      <header className="fixed-top">
        <TopLinksBar />
        <AssetClassBar />
        {isRedesignPage() && <MenuFilterBar />}
      </header>
      {isRedesignPage() ? <div className="header-spacer" /> : <div className="header-spacer-landing" />}
    </>
  );
}

export function MobileHeader() {
  return (
    <>
      <Navbar bg="primary" variant="dark" expand="md" className="flex-nowrap mb-3">
        <Nav className="flex-row w-100">
          <HeaderTitle />
          <MobileMenuButton />
        </Nav>
        <MobileMenu />
      </Navbar>
      {isRedesignPage() && <MenuFilterBar />}
    </>
  );
}
